<template>
  <div>
    <suppliers />
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
} from "bootstrap-vue";
import suppliers from "@/views/user/supplier/suppliers-list/suppliersList.vue"


export default {
  components: {
    // ModalFilter,
    BCard,
    BCardBody,
    suppliers
  },
  data() {
    return {
    };
  },
};
</script>
    
<style lang="scss" scoped>
// }
</style>
    
<style lang="scss">

</style>
    